import { useGoBack } from '@/state/useGoBack';
import { useT } from '@/state/useT';
import { BackIcon } from './Icons';

/**
 * The bar at the top of a screen reached from somewhere else: one button back
 * and the screen's name. Three screens carried a byte-identical copy of it.
 *
 * Back is a history pop rather than a route, so it returns to wherever the
 * person actually came from — the report is reachable from the tab bar and
 * from Home, and a fixed destination would be wrong for one of them.
 * `fallback` is only for when there is no history of ours to pop.
 */
export function BackBar({ title, fallback = '/' }: { title: string; fallback?: string }) {
  const { t } = useT();
  const back = useGoBack(fallback);

  return (
    <div className="app-header" style={{ justifyContent: 'flex-start', gap: 6 }}>
      <button type="button" className="backb" aria-label={t('settings.back')} onClick={back}>
        <BackIcon />
      </button>
      <h1 className="title" style={{ margin: 0 }}>
        {title}
      </h1>
    </div>
  );
}
